"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingProviders = exports.TrackingProviderValues = void 0;
const TrackingProviders = exports.TrackingProviders = {
  GA: 'Google Analytics and Google Tag Manager',
  Tealium: 'Tealium',
  Matomo: 'Matomo',
  CustomDataLayer: 'Custom Data Layer'
};
const TrackingProviderValues = exports.TrackingProviderValues = {
  GA: 'GA',
  Tealium: 'Tealium',
  Matomo: 'Matomo',
  CustomDataLayer: 'CustomDataLayer'
};